import vincentricLogo from '../assets/images/vincentric-logo.png'
import Tooltip from './Tooltip'

export default function VincentricCredit() {
  const tooltipContent = `©2025 Vincentric, LLC . The data provided by Vincentric is provided AS IS without warranty or guarantee of any kind, and Vincentric disclaims all warranties or conditions of any kind, expressed or implied, with respect to such data, including the implied warranties of merchantable quality and fitness for a particular purpose.`

  const vincentricButton = (
    <div className="flex items-center gap-1">
      <span 
        className="underline cursor-help italic"
        style={{ 
          color: 'var(--Grays-Gray, #5D5D5D)',
          fontSize: '10px'
        }}
      >
        Ownership cost data provided by
      </span>
      <img 
        src={vincentricLogo} 
        alt="Vincentric" 
        style={{ width: '133px', height: '40px' }}
      />
    </div>
  )

  const vincentricContent = (
    <div className="whitespace-pre-wrap leading-relaxed">
      {tooltipContent}
    </div>
  )

  return (
    <Tooltip button={vincentricButton} content={vincentricContent} />
  )
}
